var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 4,
    viewBox: "0 0 21 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13743 2C3.13743 2.19891 3.02479 2.38968 2.8243 2.53033C2.6238 2.67098 2.35187 2.75 2.06833 2.75C1.78478 2.75 1.51286 2.67098 1.31236 2.53033C1.11187 2.38968 0.999228 2.19891 0.999228 2C0.999228 1.80109 1.11187 1.61032 1.31236 1.46967C1.51286 1.32902 1.78478 1.25 2.06833 1.25C2.35187 1.25 2.6238 1.32902 2.8243 1.46967C3.02479 1.61032 3.13743 1.80109 3.13743 2ZM11.6902 2C11.6902 2.19891 11.5776 2.38968 11.3771 2.53033C11.1766 2.67098 10.9047 2.75 10.6211 2.75C10.3376 2.75 10.0657 2.67098 9.86516 2.53033C9.66466 2.38968 9.55202 2.19891 9.55202 2C9.55202 1.80109 9.66466 1.61032 9.86516 1.46967C10.0657 1.32902 10.3376 1.25 10.6211 1.25C10.9047 1.25 11.1766 1.32902 11.3771 1.46967C11.5776 1.61032 11.6902 1.80109 11.6902 2ZM20.243 2C20.243 2.19891 20.1304 2.38968 19.9299 2.53033C19.7294 2.67098 19.4575 2.75 19.1739 2.75C18.8904 2.75 18.6184 2.67098 18.4179 2.53033C18.2175 2.38968 18.1048 2.19891 18.1048 2C18.1048 1.80109 18.2175 1.61032 18.4179 1.46967C18.6184 1.32902 18.8904 1.25 19.1739 1.25C19.4575 1.25 19.7294 1.32902 19.9299 1.46967C20.1304 1.61032 20.243 1.80109 20.243 2Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.919ef111737e39fadae2eb9e8259b259.svg";
export { ForwardRef as ReactComponent };